import Link from 'next/link'
import { styled } from 'styled-components'

import { useGetPosts } from 'src/hooks/posts/useGetPosts'
import { addSizeToUrl } from '@/util/imgHelpers'

export const RecentPostsSection = ({ currentPostId }) => {
  const { posts: recentPosts, isLoading } = useGetPosts({
    orderBy: 'approvedAt',
    orderDirection: 'desc',
    limit: 9,
  })

  const filteredRecentPosts = recentPosts.filter(p => p.id !== currentPostId)

  if (isLoading) return <p className="text-sm text-neutral-500">Loading recent posts...</p>
  if (!filteredRecentPosts.length) return null

  return (
    <section className="mt-8">
      <div className="flex items-center mb-4">
        <h2 className="font-soehne-kraftig text-xl tracking-tight">Recent Posts</h2>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 dt:grid-cols-4 gap-3">
        {filteredRecentPosts.map(post => (
          <Link key={post.id} href={`/discover/${post.id}`} passHref legacyBehavior>
            <PostTile>
              <img
                src={addSizeToUrl(post.coverImg, post.coverImgTitle)}
                alt={post.title}
              />
            </PostTile>
          </Link>
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          href="/discover"
          passHref
        >
          <a
            className="
              px-6 py-2
              border border-neutral-400
              rounded-md
              font-soehne-leight text-sm text-gray-700
              hover:bg-l-94 hover:border-gray-600
              transition
              cursor-pointer
              select-none
            "
          >
            View All Posts
          </a>
        </Link>
      </div>
    </section>
  )
}

const PostTile = styled.a`
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    transform: scale(1.015);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
`